import { addListener } from "@common/helpers/domManipulation";
import { isVisible } from "@common/helpers/domManipulation";
import { events } from "@common/helpers/events";

import QuoteCarouselDomElements from "./quoteCarouselBlock.dom.elements";

function init($views) {
	$views.forEach(($view) => {
		const dom = new QuoteCarouselDomElements($view);

		let $bxSlider;

		if (initSlider()) {
			initEvents();
		}

		function initSlider() {
			const $slider = $(dom.slider());
			const hasSlides = dom.sliderItemElements().length > 1;

			if (hasSlides) {
				$bxSlider = $slider.bxSlider({
					auto: false,
					pause: 5000,
					controls: true,
					pager: false,
					onSliderLoad: function () {
						dom.component().style.visibility = "visible";
					},
				});

				addListener(dom.buttonNext(), "click", (event) => {
					event.preventDefault();
					$bxSlider.goToNextSlide();
				});

				addListener(dom.buttonPrevious(), "click", (event) => {
					event.preventDefault();
					$bxSlider.goToPrevSlide();
				});

				return true;
			}

			return false;
		}

		function initEvents() {
			addListener($view, events.TABS_SWITCHED, redrawCarousel.bind(this));
			addListener($view, events.ACCORDION_OPENED, redrawCarousel.bind(this));
		}

		function redrawCarousel() {
			if (isVisible($bxSlider)) {
				$bxSlider.redrawSlider();
			}
		}
	});
}

export default {
	view: "quoteCarouselBlock",
	init,
};
